/* eslint-disable @typescript-eslint/no-unused-vars */
import { Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useContext } from 'react';
import { ScrollableContainer } from '../../components';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import NavigationContext from '../../contexts/NavigationContext';
import useStyles from './styles';

interface AuthProps {
  children: JSX.Element;
  title?: string;
}

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
  open?: boolean;
}>(({ theme, open }) => ({
  zIndex: 1,
  flex: '1 1 0',
  // flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Content = styled('div')(({ theme }) => ({
  padding: theme.spacing(4),
  flex: '1',
  // minHeight: '100%',
  display: 'flex',
}));

const AuthLayout = ({ children, title }: AuthProps) => {
  const styles = useStyles();
  const { isDrawerMini } = useContext(NavigationContext);

  return (
    <div className={styles.container}>
      <Header title={title} />
      <Sidebar />
      <Main open={isDrawerMini}>
        <Toolbar sx={{ marginTop: '3px' }} />

        <div className={styles.content}>
          <ScrollableContainer>
            <Content>{children}</Content>
          </ScrollableContainer>
        </div>
      </Main>
    </div>
  );
};

export default AuthLayout;
